export class DocumentMangListLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            documentManagement: lang.doc_mang[0],
            code: lang.doc_mang[1],
            title: lang.doc_mang[2],
            documentType: lang.doc_mang[4],
            origin: lang.doc_mang[5],
            actualRevision: lang.doc_mang[6],
            currentRevision: lang.doc_mang[7],
            writtenBy: lang.doc_mang[8],
            expiryDate: lang.doc_mang[9],
            daysleft: lang.doc_mang[64],
            status: lang.doc_mang[33],
            selectColumns: lang.general[9],
            selectAll: lang.general[10],
            close: lang.general[17],
            exportCSV: lang.general[13],
            exportPDF: lang.general[14],
            exportExcel: lang.general[15],
            print: lang.general[16],
            action: lang.doc_mang[65],
            managementsystemdoc: lang.doc_mang[52],
            procedure: lang.doc_mang[53],
            instruction: lang.doc_mang[54],
            safetydoc: lang.doc_mang[55],
            specification: lang.doc_mang[56],
            select: lang.general[67],
            valid: lang.doc_mang[70],
            passed: lang.doc_mang[71],
            requiredField: lang.doc_mang[75],
            doccodealreadyexists: lang.doc_mang[101],
            editDocument: lang.doc_mang[49],
            createDocument: lang.doc_mang[69],            
            revision: lang.doc_mang[80],            
            revisionDate: lang.doc_mang[79],            
            generalData: lang.doc_mang[18],            
            repetititonData: lang.doc_mang[94],            
            firstemissionDate: lang.doc_mang[36],            
            repeatingPeriod: lang.doc_mang[28],             
            daystoNotify: lang.doc_mang[88],             
            notificationTime: lang.doc_mang[100],             
            selectTime: lang.doc_mang[97],
            referenceEmail: lang.doc_mang[61],
            importDocument: lang.doc_mang[30],
            save: lang.general[0],
            selectDocumentType: lang.doc_mang[90],
            selectOrigin: lang.doc_mang[91],
            selectStatus: lang.doc_mang[92],
            erase: lang.general[4],
            modify: lang.general[2],
            view: lang.general[3],
            internal: lang.doc_mang[57],
            external: lang.doc_mang[58],
        }

    }

    lang() {
        return this.variables;
    }

}
export class DocumentViewActionLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            documentManagement: lang.doc_mang[0],
            code: lang.doc_mang[1],
            title: lang.doc_mang[2],
            documentType: lang.doc_mang[3],
            origin: lang.doc_mang[4],
            actualRevision: lang.doc_mang[5],
            currentRevision: lang.doc_mang[6],
            writtenBy: lang.doc_mang[8],
            expiryDate: lang.doc_mang[9],
            daysleft: lang.doc_mang[64],
            status: lang.doc_mang[33],
            selectColumns: lang.general[9],
            selectAll: lang.general[10],
            close: lang.general[17],
            exportCSV: lang.general[13],
            exportPDF: lang.general[14],
            exportExcel: lang.general[15],
            print: lang.general[16],
            action: lang.doc_mang[65],
            managementsystemdoc: lang.doc_mang[52],
            procedure: lang.doc_mang[53],
            instruction: lang.doc_mang[54],
            safetydoc: lang.doc_mang[55],
            specification: lang.doc_mang[56],
            select: lang.general[67],
            valid: lang.doc_mang[70],
            passed: lang.doc_mang[71],
            requiredField: lang.doc_mang[75],
            doccodealreadyexists: lang.doc_mang[101],
            editDocument: lang.doc_mang[49],
            createDocument: lang.doc_mang[69],            
            revision: lang.doc_mang[31],            
            revisionDate: lang.doc_mang[79],            
            descriptionofChanges: lang.doc_mang[23],            
            attachments: lang.doc_mang[3],          
            verifiedBy: lang.doc_mang[66],          
            approvedBy: lang.doc_mang[67],          
            distributionStatus: lang.doc_mang[24],          
            sendTo: lang.doc_mang[25],          
            dateofSent: lang.doc_mang[26],          
            generalData: lang.doc_mang[18],          
            repetitionData: lang.doc_mang[94],          
            documentView: lang.doc_mang[59],          
            addRevision: lang.doc_mang[22],          
            currentrevisionDate: lang.doc_mang[7],  
            verfiedBy: lang.doc_mang[66],
            save: lang.general[0],
            selectDocumentType: lang.doc_mang[90],
            selectOrigin: lang.doc_mang[91],
            selectStatus: lang.doc_mang[92],
            erase: lang.general[4],
            modify: lang.general[2],
            view: lang.general[3],
            internal: lang.doc_mang[57],
            external: lang.doc_mang[58],
            duplicate: lang.doc_mang[62],
            mail: lang.general[5],

        }

    }

    lang() {
        return this.variables;
    }

}


